
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useSimpleAuth } from "@/hooks/useSimpleAuth";

export function ProtectedRoute() {
  const location = useLocation();
  const { isAuthenticated } = useSimpleAuth();
  const auth = isAuthenticated();

  useEffect(() => {
    console.log("ProtectedRoute - Estado atual:", {
      auth,
      pathname: location.pathname,
      state: location.state
    });
  }, [location, auth]);

  if (!auth) {
    console.log("ProtectedRoute - Usuário não autenticado, redirecionando para /auth");
    return <Navigate to="/auth" state={{ from: location.pathname }} replace />;
  }

  console.log("ProtectedRoute - Usuário autenticado, permitindo acesso a:", location.pathname);
  return <Outlet />;
}
